import { Tune } from '@tempo-io/sui-icons';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '@/common/components/empty-state/EmptyState';

type VisualizationNoItemsMatchLayoutStateProps = {
  onOpenFormatPanel?: () => void;
};

export const VisualizationNoItemsMatchLayoutState = ({
  onOpenFormatPanel,
}: VisualizationNoItemsMatchLayoutStateProps) => {
  const { t } = useTranslation();

  return (
    <EmptyState
      variant="search"
      title={t(($) => $.views.visualization.emptyStates.noItemsMatchLayoutOptions.title)}
      description={t(
        ($) => $.views.visualization.emptyStates.noItemsMatchLayoutOptions.description,
      )}
      primaryAction={
        onOpenFormatPanel
          ? {
              label: t(($) => $.views.visualization.emptyStates.noItemsMatchLayoutOptions.button),
              onClick: onOpenFormatPanel,
              icon: <Tune />,
            }
          : undefined
      }
    />
  );
};
